import React, { useEffect, useState } from "react";
import LayoutWithSideMenu from "../../components/LayoutWithSideMenu";
import Panel from "../../components/Panel";
import PanelInvisible from "../../components/PanelInvisible";
import Text from "../../components/Text";
import PageTitle from "../../components/PageTitle";

import { withLang } from "../../components/Text/withLang";

const ContactScreenBase = props => {
    const [contactInfo, setContactInfo] = useState("");

    useEffect(() => {
        getContactInfo();
    });

    async function getContactInfo() {
        let contactInfo = await props.service.getContactHTML("contact", props.lang);
        setContactInfo(contactInfo);
    }

    return (
        <>
            <PanelInvisible>
                <PageTitle value={<Text value="Contact" />} />
            </PanelInvisible>
            <PanelInvisible>
                <Panel id={`panel-contact`}>
                    <div dangerouslySetInnerHTML={{ __html: contactInfo }} />
                </Panel>
            </PanelInvisible>
        </>
    );
};

export default withLang(ContactScreenBase);
